<div class="suggested-container" [class.opened]="datalistOpened">
  <div
    [title]="currentSelection ? currentSelection.name : ''"
    [class.error]="hasError"
    [class.loading]="loading"
    [class.disabled]="disabled"
    [class.placeholder]="!currentSelection"
    class="suggested"
  >
    <input
      (keyup)="onSuggestedInputKeypress($event)"
      [formControl]="searchControl"
      [placeholder]="placeholder"
      [disabled]="disabled"
    />
    <i *ngIf="!loading" class="fas fa-chevron-down"></i>
    <i *ngIf="loading" class="fas fa-spinner fa-spin"></i>
  </div>

  <ul>
    <li
      *ngIf="allowCustomValue && !!customOption"
      (click)="onSuggestedOptionSelected(customOption)"
    >
      {{ customOptionText }}<strong>{{ customOption.name }}</strong>
    </li>
    <li
      *ngFor="let option of optionsAvailable"
      (click)="onSuggestedOptionSelected(option)"
      value="option.value"
    >
      {{ option.name }}
    </li>
  </ul>
</div>
